<div data-cy="external-connectional-modal__page">
    <div mat-dialog-title>
        <h4 class="mb-10 inline-block title sans-regular">
            Externe connecties beheren
        </h4>
        <button data-cy="external-connectional-modal__close-btn" type="button" class="close modal-close-button" (click)="close()">
            <span aria-hidden="true"><i class="d-text-middle uil uil-multiply unicon-icon"></i></span>
            <span class="sr-only">Close</span>
        </button>   
    </div>

    <div>
        <div class="col-xs-12">
            <span class="fw-semibold sans-regular">Gedeeld met leesrechten</span>
            <p class="mb-30 fs-14 sans-regular">De ontvangende partij mag wel informatie verrijken binnen het eigen project. Dit heeft geen invloed op jouw projectinformatie.</p>
            <app-generic-multiselect-checkbox data-cy="external-connectional-modal__generic-multiselect-checkbox" [placeholder]="'Extern gedeeld met:'" name="cnotextType"
                [(ngModel)]="selectedConnections" ngDefaultControl [uniqueId]="'context-themes'" [required]="true">
                <app-generic-multiselect-checkbox-option *ngFor="let con of allConnections" [value]="con">
                    {{ globals.project.projects_id===con.source_project_id ? con.target_project.name: con.source_project.name }}
                </app-generic-multiselect-checkbox-option>
            </app-generic-multiselect-checkbox>
        </div>
    </div>

     <mat-dialog-actions data-cy="external-connectional-modal__dialog-actions" align="end">
        <div class="dialog-button-row">
            <button data-cy="external-connectional-modal__close-btn-2" type="button" mat-stroked-button data-dismiss="modal" (click)="close()">
                {{ "cancel" | transloco | capitaliz }}
            </button>
        </div>
        <!--end of modal footer -->
    </mat-dialog-actions>
</div>